import { render, staticRenderFns } from "./footerComp.vue?vue&type=template&id=16ad703c&scoped=true&"
import script from "./footerComp.vue?vue&type=script&lang=ts&"
export * from "./footerComp.vue?vue&type=script&lang=ts&"
import style0 from "./footerComp.vue?vue&type=style&index=0&id=16ad703c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad703c",
  null
  
)

export default component.exports